import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ButtonGreen } from "./ButtonsGenerics";
import { Text } from "./Text";

export default function ModalTokenGenerado({
    token,
    fechaVencimiento,
    handleClose,
}) 
{
    const [timeLeft, setTimeLeft] = useState("");

    useEffect(() => {

        const actualizarTiempo = () => {

            const ahora = new Date().getTime();
            const vencimiento = new Date(fechaVencimiento).getTime();

            const diferencia = vencimiento - ahora;

            if (diferencia <= 0) {
                setTimeLeft("00:00");
                return;
            }

            const minutos = Math.floor(diferencia / 1000 / 60);
            const segundos = Math.floor((diferencia / 1000) % 60);

            setTimeLeft(
                `${String(minutos).padStart(2, "0")}:${String(segundos).padStart(2, "0")}`
            );
        };

        actualizarTiempo();

        const interval = setInterval(actualizarTiempo, 1000);

        return () => clearInterval(interval);

    }, [fechaVencimiento]);

    return (
        <GenerateTokenWrapper>

            <Header>
                <LogoWrapper>
                    <Text
                        fontWeight="600"
                        color="white"
                        fontSize="3rem"
                    >
                        ✔
                    </Text>
                </LogoWrapper>
            </Header>

            <Body>

                <Text
                    fontWeight="600"
                    color="#555"
                    fontSize="2rem"
                >
                    Token generado correctamente
                </Text>

                <Text fontSize="1rem">
                    Presente este código junto con su DNI.
                </Text>

                <Token>
                    {token}
                </Token>

                <Text fontSize=".9rem">
                    Tiempo restante:
                </Text>

                <Text
                    fontWeight="600"
                    fontSize="2rem"
                    color={timeLeft === "00:00" ? "#d32f2f" : "#1565c0"}
                >
                    {timeLeft}
                </Text>

            </Body>

            <Footer>

                <ButtonGreen onClick={handleClose}>
                    Aceptar
                </ButtonGreen>

            </Footer>

        </GenerateTokenWrapper>
    );
}

const GenerateTokenWrapper = styled.div`
    background: white;
    width: 500px;
    min-height: 480px;

    border-radius: 12px;
    padding: 2rem;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Header = styled.div`
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LogoWrapper = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #5cb85c;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Body = styled.div`
    margin: 3rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
`;

const Token = styled.div`
    font-size: 3rem;
    font-weight: bold;
    letter-spacing: 10px;
    color: #1565c0;
    padding: 20px 40px;
    border: 2px dashed #1565c0;
    border-radius: 10px;
    background: #f5faff;
`;

const Footer = styled.div`
    display: flex;
    justify-content: center;
`;